module.exports = __webpack_public_path__ + "static/media/nopool.15a88174.png";